<div class="row overview-container overview-items-container"
     [ngClass]="{'hide-top': (isMobile() && (scrollDirection$ | async) == scrollDown)}">
  <mojo-tilebar>
    <mojo-overview-items-container [items$]="tiles$"></mojo-overview-items-container>
  </mojo-tilebar>
</div>
